import { render, staticRenderFns } from "./Data_display.vue?vue&type=template&id=76544074&scoped=true&"
import script from "./Data_display.vue?vue&type=script&lang=js&"
export * from "./Data_display.vue?vue&type=script&lang=js&"
import style0 from "./Data_display.vue?vue&type=style&index=0&id=76544074&prod&scoped=true&lang=css&"
import style1 from "./Data_display.vue?vue&type=style&index=1&id=76544074&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76544074",
  null
  
)

export default component.exports